import { call, put, select, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';
import API from 'services/api';
import { setLoading, showSnackbar, toggleModal } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';
import { getTimezone } from 'reducers/utils';
import {
  messageActions,
  messagePageActions,
  messageFilterActions,
  messageSelectors,
  messagesNameSpace,
} from 'containers/Pages/Messages';

export function* fetchMessageListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const timezone = yield select(getTimezone);
    const { filters, from } = payload;
    const { data } = yield call(API.fetchMessagingList, {
      ...filters,
      from,
      timezone,
    });
    if (data.data) {
      const totalEntries = get(data, 'meta.total');
      yield put(messageActions.setGridList({ list: data.data, totalEntries }));
    }
    yield put(messageFilterActions.setFilterKey(false));
    yield put(messageActions.setForceRefresh(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchMessageDetailsSaga({ payload }) {
  if (!payload) return; //this has been called when the panel is not open
  try {
    yield put(setLoading(true));
    const { id } = payload;
    const rows = yield select(messageSelectors.getMessageListRaw);
    const value = rows.find(f => f.id === id);
    if (value) {
      yield put(messageActions.setGridRowDetails({ details: value }));
      // if (!value.acknowledgedAt) {
      //   yield put(messageActions.updateGridRowDetails({ details: value }));
      // }
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* sendMessageSaga({ payload }) {
  try {
    yield put(setLoading(true));
    //extract the message
    const { message } = payload;
    //transform the message to send it
    const data = {
      title: message.title,
      body: message.body,
      recipientIds: message.recipients.map(a => a.id),
    };
    const { status } = yield call(API.sendMessage, data);
    if (status === 200) {
      yield put(toggleModal(messagesNameSpace));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* acknowledgeMessageSaga() {
  try {
    yield put(setLoading(true));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* messageSagas() {
  yield takeLatest(messageActions.fetchGridList, fetchMessageListSaga);
  yield takeLatest(messageActions.fetchGridRowDetails, fetchMessageDetailsSaga);
  yield takeLatest(
    messagePageActions.refreshMessageDetails,
    fetchMessageDetailsSaga,
  );
  yield takeLatest(messageActions.createRowEntry, sendMessageSaga);
  yield takeLatest(messageActions.updateRowEntry, acknowledgeMessageSaga);
}
